import { render, staticRenderFns } from "./BridgeMaintenanceLogView.vue?vue&type=template&id=48781faa"
import script from "./BridgeMaintenanceLogView.vue?vue&type=script&lang=ts"
export * from "./BridgeMaintenanceLogView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports